import React from 'react';
import { withRouter } from 'react-router-dom';
// ANTD
import Menu from 'antd/lib/menu';
import Dropdown from 'antd/lib/dropdown';
import Icon from 'antd/lib/icon';
import notification from 'antd/lib/notification';
import message from 'antd/lib/message';
// APOLLO
import { graphql, compose } from 'react-apollo';
import deleteEmailTemplate from 'ApolloClient/Mutations/deleteEmailTemplate';
import emailTemplates from 'ApolloClient/Queries/emailTemplates';

const ICON_STYLE = { marginRight: 6, fontSize: 17 };

export class ActionMenu extends React.PureComponent {
  state = {
    loading: false,
  };

  onDelete = async () => {
    const { record, deleteEmailTemplate } = this.props; // destructure
    this.setState({ loading: true }); // start loader

    try {
      await deleteEmailTemplate({
        variables: { _id: record._id },
        refetchQueries: [
          {
            query: emailTemplates,
            variables: {},
          },
        ],
      });
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
      return message.error(err.message);
    }
    notification.success({ message: 'Email Template successfully deleted!' });
    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  handleMenuClick = ({ key }) => {
    switch (key) {
    case '4':
      return this.onDelete();
    default:
      return null;
    }
  };

  render() {
    return (
      <div style={s.container}>
        <Dropdown
          trigger={['click']}
          overlay={(
            <Menu onClick={this.handleMenuClick}>
              <Menu.Item key="4">
                <Icon type="delete" style={ICON_STYLE} />
                Delete Template
              </Menu.Item>
            </Menu>
          )}
        >
          {this.state.loading ? (
            <Icon type="loading" style={s.loadingIcon} />
          ) : (
            <Icon type="ellipsis" style={{ fontSize: 20, fontWeight: 600 }} />
          )}
        </Dropdown>
      </div>
    );
  }
}

const s = {
  loadingIcon: {
    fontSize: 20,
    color: '#f29980',
    fontWeight: 600,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuItem: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
};

export default compose(graphql(deleteEmailTemplate, { name: 'deleteEmailTemplate' }))(withRouter(ActionMenu));



// WEBPACK FOOTER //
// ./src/routes/app-studio/EmailTemplatesArea/EmailTemplatesTable/ActionMenu.js